import { isMobileDevice } from "../util/mobile";

const getApiEndpoint = () => {
  if (process.env.NODE_ENV === "development") {
    if (isMobileDevice()) return "http://192.168.0.135:3000";
    return "http://localhost:3000";
  }
  return "https://safebox-server.now.sh";
};

export default {
  API_ENDPOINT: getApiEndpoint(),
  JWT_COOKIE: "safebox_jwt",
  PIN_LENGTH: 6
};
